// extracted by mini-css-extract-plugin
export default {"detector":"NetworkDetector_detector__HHBT0","online":"NetworkDetector_online__p2lek","icon":"NetworkDetector_icon__W110R","info":"NetworkDetector_info__rfBxI"};